import { Entity } from '../../../../../game';
import { SHIP } from '../../../../../traits';
import { Vector } from '../../../../../types';
import { add, contains, multiplyScalar } from '../../../../../utils';

export class BulletsEntity extends Entity {
  positions: Vector[] = [];
  velocity: Vector = [0, SHIP.bulletVelocity, 0];
  max: Vector = [Infinity, 300, Infinity];
  min: Vector = [-Infinity, 0, -Infinity];

  step(delta: number) {
    for (let i = 0; i < this.positions.length; i++) {
      this.positions[i] = add(
        this.positions[i],
        multiplyScalar(this.velocity, delta),
      );
      if (!contains(this.positions[i], this.min, this.max)) {
        this.positions.splice(i, 1);
        i--;
      }
    }
  }

  fire(position: Vector) {
    this.positions.push(position);
  }

  checkCollision(): boolean {
    return false;
  }
}
